import { render, staticRenderFns } from "./rating.vue?vue&type=template&id=9707fd6e&"
import script from "./rating.vue?vue&type=script&lang=js&"
export * from "./rating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports